import { Component, ViewEncapsulation, SimpleChanges, OnInit, OnChanges } from '@angular/core';

import { Vraag, Antwoord } from '@models/claims';
import { SelectieItem, VraagboomSelectieResultaat } from '@models/vragenboom';
import { BaseVraagControlDirective } from '../base/base-vraag-control';
import { TextValidator } from '../../../utils/validation/text.validator';
import { DataService } from '@components/public_api';

@Component({
  selector: 'app-single-choice-with-filter',
  templateUrl: './single-choice-with-filter.component.html',
  styleUrls: ['./single-choice-with-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SingleChoiceWithFilterComponent extends BaseVraagControlDirective<VraagboomSelectieResultaat> implements OnChanges, OnInit {
  placeholder = '';
  filterAltijdTonen = '';
  filterItems: SelectieItem[] = [];
  huidigeSelectie: VraagboomSelectieResultaat;

  constructor(_dataService: DataService) {
    super(_dataService);
  }
  ngOnInit(): void {
    if (this.vraag?.antwoorden && this.vraag.antwoorden.length > 0) {
      this.placeholder = this.vraag.antwoorden[0].standaard_waarde_tekst;

      this.vraag.antwoorden.forEach((antwoord) => {
        let omschrijving = (antwoord.antwoord_bullets && antwoord.antwoord_bullets.length > 0) ? antwoord.antwoord_bullets[0] : null;
        this.filterItems.push(new SelectieItem({code: antwoord.id, titel: antwoord.titel, omschrijving: omschrijving}));
      });
    }
  }

  initialize(changes: SimpleChanges): void {
    this.huidigeSelectie = new VraagboomSelectieResultaat('', '', '');
    if (this.antwoordResultaat != null && this.antwoordResultaat.resultaat != null && this.antwoordResultaat.antwoorden != null) {
      this.huidigeSelectie = new VraagboomSelectieResultaat(this.antwoordResultaat.resultaat.code, this.antwoordResultaat.resultaat.titel, this.antwoordResultaat.resultaat.omschrijving);
    }
  }

  notifyAntwoord(selectie: VraagboomSelectieResultaat) {
    let antwoord = this.vraag.antwoorden.find(a => a.id === selectie.code);
    if (antwoord) {
      this.setAntwoord([].concat(antwoord), selectie);
    }
  }

  validate(vraag: Vraag, antwoorden: Antwoord[], resultaat: VraagboomSelectieResultaat): boolean {
    return antwoorden?.length >= 1 && TextValidator.isValidSelectie(vraag, resultaat);
  }
}
